import { useEffect, lazy } from 'react';
import { useMediaQuery, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Container } from '~/content/components/Container';
import Scroll from 'react-scroll';

import Features from './features';
import Hero from './hero';
// import HowItWorks from './howItWorks';
// import About from './about';
// import MobileApp from './mobileApp';
// import Contact from '~/content/components/Contact';
// import Articles from "./articles";
// import Partners from './partners';
// import Pricings from './pricings';
// import Reviews from './reviews';
// import Storage from './storage';
// import Story from './story';

const About = lazy(() => import('./about.tsx'));
const MobileApp = lazy(() => import('./mobileApp.tsx'));
const Storage = lazy(() => import('./storage.tsx'));
const Story = lazy(() => import('./story.tsx'));
const Contact = lazy(() => import('~/content/components/Contact'));

import { trackPageview } from '~/utils/plausible';
import { useTranslation } from 'react-i18next';

const Workflows = (): JSX.Element => {
	let { t } = useTranslation(['workflows']);

	const size = '3px';
	const gap = '16px';

	const theme = useTheme();
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	useEffect(() => {
		trackPageview();
	}, []);
	return (
		<>
			<Box
				pt={isMd ? 4 : 0}
				pb={isMd ? 8 : 0}
				position={'relative'}
				sx={{
					backgroundColor: theme.palette.alternate.main,
				}}
			>
				<Container>
					<Hero />
				</Container>
			</Box>

			{/* Overview */}
			<Scroll.Element name='features' />
			<Box pt={isMd ? 3 : 0} pb={isMd ? 5 : 1}>
				<Container>
					{/* <Container paddingTop={'75px !important'} paddingBottom={'75px !important'}> */}
					<Features />
				</Container>
			</Box>

			{/* Datenerhebung */}
			{/* <Scroll.Element name='datenerhebung' /> */}
			<Box bgcolor='alternate.main' pt={isMd ? 3 : 2} pb={isMd ? 5 : 1}>
				{/* <Container paddingTop={'75px !important'} paddingBottom={'75px !important'}> */}
				<Container>
					<Story />
				</Container>
			</Box>

			{/* Datenspeicherung */}
			{/* <Scroll.Element name='datenspeicherung' /> */}
			<Box pt={isMd ? 4 : 3} pb={isMd ? 5 : 0}>
				{/* <Container paddingTop={'90px !important'} paddingBottom={'90px !important'}> */}
				<Container>
					<About />
				</Container>
			</Box>

			{/* Datenverarbeitung */}
			{/* <Scroll.Element name='datenverarbeitung' /> */}
			<Box bgcolor='alternate.main' pt={isMd ? 5 : 3} pb={isMd ? 5 : 0}>
				{/* <Container paddingTop={'90px !important'} paddingBottom={'75px !important'}> */}
				<Container>
					<MobileApp />
				</Container>
			</Box>

			{/* Datenanalyse */}
			<Scroll.Element name='datenanalyse' />
			<Box pt={isMd ? 5 : 3} pb={isMd ? 5 : 2}>
				{/* <Container paddingTop={'75px !important'} paddingBottom={'75px !important'}> */}
				<Container>
					<Storage />
				</Container>
			</Box>

			{/* Kontakt */}
			<Box bgcolor='alternate.main'>
				<Box
					pt={{ xs: 5, md: 9 }}
					pb={{ xs: 5, md: 9 }}
					bgcolor={theme.palette.primary.light}
					sx={{
						position: 'relative',

						'&::after': {
							position: 'absolute',
							content: '""',
							// width: '25%',
							zIndex: 1,
							top: 0,
							width: isMd ? '25%' : '0%',
							left: '5%',
							height: '93%',
							inset: gap,
							WebkitMask: `
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0,
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0;
									`,
							WebkitMaskSize: `calc(${size} + ${gap}) calc(${size} + ${gap})`,
							background: theme.palette.primary.main,
							opacity: 0.1,
						},
					}}
				>
					<Container>
						{/* <Container paddingTop={'90px !important'} paddingBottom={'90px !important'}> */}
						<Contact leftButtonText={t('mini_contact_button_1')} />
					</Container>
				</Box>
			</Box>
		</>
	);
};

export default Workflows;
